/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {executeCashOut} from '../api'

export const useMutationExecuteCashOut = createReactQueryMutationHook('executeCashOut', executeCashOut)
